"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@commerce-ui/core2/selectables/Checkbox"));
var _Checkmark = _interopRequireDefault(require("../Checkmark"));
var _CheckmarkAlternative = _interopRequireDefault(require("../CheckmarkAlternative"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Checkbox = function Checkbox(props) {
  var _props$alternativeSty = props.alternativeStyling,
    alternativeStyling = _props$alternativeSty === void 0 ? false : _props$alternativeSty;
  var check = alternativeStyling ? __jsx(_CheckmarkAlternative["default"], {
    sx: {
      pt: 5
    }
  }) : __jsx(_Checkmark["default"], {
    sx: {
      pt: 5
    }
  });
  var labelContainerStyle = alternativeStyling ? {
    pl: 8,
    pt: 2
  } : {
    pl: 8
  };
  return __jsx(_Checkbox["default"], (0, _extends2["default"])({}, props, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled;
      return _objectSpread({
        $checkmark: check,
        $labelContainer: _objectSpread({}, labelContainerStyle),
        $label: {
          font: "body2",
          color: "main"
        },
        $description: {
          font: "body2",
          color: "neutral900"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkbox;
exports["default"] = _default;